import { useEffect, useState } from "react";
import "./index.scss";
import { isValidNumberWithinBoundary } from "utils/numbers";
import { DSButton } from "components/UI/atoms";
import { nameToSlug } from "utils/strings";
import { useAppContext } from "context/app-context";
import { INTERNAL_PATHS } from "routes/paths";
import { setReturnToCookie } from "services/cookies";

export const BrandCashBuyNow = ({
  isApple,
  instantConfigId,
  affiliateUrl,
  selected,
  cashBack,
  amount,
  min_value,
  max_value,
  gifting_supported,
  name
}) => {
  const {
    sessionInfo: { isLoggedIn }
  } = useAppContext();

  const [formattedGCXCash, setFormattedGCXCash] = useState(0);

  const isDisabled =
    selected === "input" &&
    !isValidNumberWithinBoundary(amount, {
      min: min_value,
      max: max_value
    });

  const getRedirectPath = (isGift) => {
    if (!isLoggedIn) return INTERNAL_PATHS.USER_LOG_IN;

    const slug = nameToSlug(name);
    const isAppleString = isApple ? "TRUE" : "FALSE";
    const path = `/checkout?id=${instantConfigId}&amount=${amount}&gift=${(!!isGift).toString()}&slug=${slug}&isApple=${isAppleString}`;

    return path;
  };

  const handleClick = (isGift) => {
    if (!isLoggedIn) {
      setReturnToCookie(window.location.href);
      return window.open(INTERNAL_PATHS.USER_LOG_IN);
    }

    window.open(getRedirectPath(isGift));

    setTimeout(() => {
      affiliateUrl && window.location.assign(affiliateUrl);
    }, 400);
  };

  useEffect(() => {
    const minAmount = max_value ? Math.min(amount, max_value) : amount;
    const factor = Math.pow(10, 2);
    const centsMultiplier = 0.0001;
    const GCXCash =
      Math.round(minAmount * cashBack * centsMultiplier * factor) / factor;

    setFormattedGCXCash(GCXCash.toFixed(2));
  }, [max_value, cashBack, amount]);

  return (
    <div className="brand-cash-buy-now">
      <p className="discount">
        You earn <br />
        {`$${formattedGCXCash} GCX Cash`}
      </p>
      <DSButton
        customClassName="buy-now-button"
        onClick={() => handleClick(false)}
        disabled={isDisabled}
      >
        BUY NOW
      </DSButton>
      {gifting_supported && (
        <DSButton
          customClassName="gift-button"
          variant="ghost"
          iconPosition="right"
          icon={<div className="arrow-icon">&#8250;</div>}
          onClick={() => handleClick(true)}
          disabled={isDisabled}
        >
          Send as a gift
        </DSButton>
      )}
    </div>
  );
};
